import { render } from "./ProfileInfo.vue?vue&type=template&id=9eb56e3e&scoped=true&ts=true"
import script from "./ProfileInfo.vue?vue&type=script&lang=ts"
export * from "./ProfileInfo.vue?vue&type=script&lang=ts"

import "./ProfileInfo.vue?vue&type=style&index=0&id=9eb56e3e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9eb56e3e"]])

export default __exports__